// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rightColumn":"_534Fj6","feedbackSuccessIcon":"BfroWD","textTitle":"_2PINRW","reviewerEditorWrapper":"_1lBYYJ","renderToolTip":"_2CrbLF"};